import React, { useEffect } from 'react';
import Sample from '@/component/module_sku/sample';
import Product from '@/component/module_sku/product';
import Express from '@/component/module_sku/express';
import ExpressStore from '@/stores/express';

interface PropType {
  skuAttrs: SkuTypes.SkuAttr[];
  price: PriceTypes.Root;
  i18n: { [key: string]: string };
  inventory: InventoryTypes.Root;
  skuInfoMap: InventoryTypes.SkuInfoMap;
  // 区分页面和弹窗不同组件入口
  moduleName: string;
  sampleInfo: SampleTypes.Root;
  type: SkuTypes.TypeInfo;
  moq: number;
  renderConfig: DetailTypes.renderConfig<{
    showType: string;
  }>;
  visitCountry: string;
  productId: number;
  hasLogistics: boolean;
  productIsMarketGoods: boolean;
  sourcingTradeAvailable: boolean;
  isDispatchGuaranteed: boolean;
  pcSemiSwitch: boolean;
  coreCountry: boolean;
  abtest: DetailTypes.Abtest;
  skuInventoryMap: InventoryTypes.SkuInfoMap;
  dispatchId: string;
  aliId: number;
}

const ResetStore = (props: PropType) => {
  const {
    skuAttrs = [],
    skuInfoMap,
    type = 'product',
    sampleInfo,
    dispatchId,
    skuInventoryMap,
  } = props;

  const expressStore = ExpressStore((state) => state);

  useEffect(() => {
    if (!expressStore.dispatchId) {
      expressStore.setDispatchById(dispatchId);
    }
  }, []);

  return (
    <>
      <Sample
        sampleInfo={sampleInfo}
        skuInfoMap={skuInfoMap}
        skuAttrs={skuAttrs}
        skuInventoryMap={skuInventoryMap}
        type={type}
      />
      <Product
        skuInfoMap={skuInfoMap}
        skuAttrs={skuAttrs}
        skuInventoryMap={skuInventoryMap}
        type={type}
      />
      <Express {...props} />
    </>
  );
};

export default ResetStore;
